import { useAppSelector } from '@/store/hooks'

export default function useManufacturerOptions() {
  const { availableManufacturers } = useAppSelector(s => s.turbines)
  return availableManufacturers?.map(i => ({
    text: i,
    value: i
  }))
}
